import {
  Box,
  BoxProps,
  VStack,
  HStack,
  Heading,
  Text,
  Divider,
} from "@chakra-ui/react";
import React from "react";

const CARD_PADDING = "1.25rem";
// full width, ignoring container padding
export const CARD_FULL_WIDTH = `calc(100% + ${CARD_PADDING} * 2)`;

export interface ActionCardProps extends BoxProps {
  heading?: React.ReactNode;
  subheading?: React.ReactNode;
  actions?: React.ReactNode;
  content: React.ReactNode;
  leftIcon?: React.ReactNode;
}

export const ActionCard = ({
  heading,
  subheading,
  content,
  actions,
  leftIcon,
  ...rest
}: ActionCardProps) => (
  <Box
    w="full"
    shadow="md"
    borderWidth="1px"
    borderRadius="0.5rem"
    borderColor="gray.200"
    borderTopWidth="0.4rem" // top accent
    borderTopColor="primary.500"
    bgColor="white"
    {...rest}
  >
    <VStack
      spacing={5}
      divider={<Divider borderColor="gray.300" />}
      paddingY={CARD_PADDING}
    >
      {heading && (
        <HStack paddingX={CARD_PADDING} w="full" spacing={3} align="flex-start">
          {leftIcon}
          <VStack alignItems="flex-start">
            <Heading fontSize="2xl">{heading}</Heading>
            <Text>{subheading}</Text>
          </VStack>
        </HStack>
      )}
      <VStack paddingX={CARD_PADDING} w="full" spacing={3} align="flex-start">
        {content}
      </VStack>
      {actions && (
        <HStack
          paddingX={CARD_PADDING}
          w="full"
          justify="flex-end"
          wrap={"wrap"}
          spacing={4}
        >
          {actions}
        </HStack>
      )}
    </VStack>
  </Box>
);
